// extracted by mini-css-extract-plugin
export default {"ShortcutWidget":"ShortcutWidget_ShortcutWidget__3Ati-","ToolsList":"ShortcutWidget_ToolsList__Vsi1m","NoTools":"ShortcutWidget_NoTools__rp1Fi"};